<template>
  <section>
    <div>
      <coozzy-card
        :title="$t('message.createOrder.orderDetails')">
        <div class="row">
          <div class="col">
            <label for="employee">{{ $t('message.createOrder.orderCreator') + '*' }}</label>
            <coozzy-form-select
              id="employee"
              v-model="emitting.selectedEmployee"
              :state="$v.emitting.selectedEmployee.$dirty && $v.emitting.selectedEmployee.$error ? false : null"
              name="employee">
              <option value="">
                -
              </option>
              <option
                v-for="element in employeeContacts"
                :key="element.id"
                :value="element.id">
                {{ element.profile.lastName }} {{ element.profile.firstName }}
              </option>
            </coozzy-form-select>
          </div>
          <div class="col-12 mt-3">
            <label>{{ $t('message.createOrder.contactPersonOnSite') }} </label>
            <div class="row px-3 mt-3">
              <template>
                <coozzy-form-radio
                  v-if="employeeContacts.length > 0"
                  v-model="emitting.onSiteContactType"
                  :default-model="emitting.onSiteContactType"
                  class="col"
                  name="typeContact"
                  select-value="VIEWING_APPOINTMENT_CONTACT_TYPE_ASSIGNEE">
                  {{ $t('message.generic.user') }}
                </coozzy-form-radio>
                <coozzy-form-radio
                  v-if="tenantContacts.length > 0"
                  v-model="emitting.onSiteContactType"
                  :default-model="emitting.onSiteContactType"
                  class="col"
                  name="typeContact"
                  select-value="VIEWING_APPOINTMENT_CONTACT_TYPE_TENANT">
                  {{ $t('message.generic.tenant') }}
                </coozzy-form-radio>
                <coozzy-form-radio
                  v-if="condoOwnersContact.length > 0"
                  v-model="emitting.onSiteContactType"
                  :default-model="emitting.onSiteContactType"
                  class="col"
                  name="typeContact"
                  select-value="VIEWING_APPOINTMENT_CONTACT_TYPE_CONDO_OWNER">
                  {{ $t('message.generic.condo_owner') }}
                </coozzy-form-radio>
                <coozzy-form-radio
                  v-if="listJanitors.length > 0"
                  v-model="emitting.onSiteContactType"
                  :default-model="emitting.onSiteContactType"
                  class="col"
                  name="typeContact"
                  select-value="VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER">
                  {{ $t('message.contact.types.janitor') }}
                </coozzy-form-radio>
                <coozzy-form-radio
                  v-if="serviceProviderContacts.length > 0"
                  v-model="emitting.onSiteContactType"
                  :default-model="emitting.onSiteContactType"
                  class="col"
                  name="typeContact"
                  select-value="VIEWING_APPOINTMENT_CONTACT_TYPE_SERVICE_PROVIDER">
                  {{ $t('message.contact.types.SERVICE_PROVIDER') }}
                </coozzy-form-radio>
                <coozzy-form-radio
                  v-if="craftsmanContacts.length > 0"
                  v-model="emitting.onSiteContactType"
                  :default-model="emitting.onSiteContactType"
                  class="col"
                  name="typeContact"
                  select-value="VIEWING_APPOINTMENT_CONTACT_TYPE_CRAFTSMAN">
                  {{ $t('message.contact.types.CRAFTSMAN') }}
                </coozzy-form-radio>
                <coozzy-form-radio
                  v-if="delegateContacts.length > 0"
                  v-model="emitting.onSiteContactType"
                  :default-model="emitting.onSiteContactType"
                  class="col"
                  name="typeContact"
                  select-value="VIEWING_APPOINTMENT_CONTACT_TYPE_DELEGATE">
                  {{ $t('message.contact.types.DELEGATE') }}
                </coozzy-form-radio>
              </template>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div
                v-if="emitting.onSiteContactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_ASSIGNEE'"
                class="col-12 mt-3">
                <coozzy-form-select
                  v-model="onSiteContactPersonId"
                  class="select-entries float-right"
                  name="numberEntries">
                  <option value="">
                    -
                  </option>
                  <option :value="emitting.selectedEmployee">
                    {{ $t('message.createOrder.sameAsOrderCreator') }}
                  </option>
                  <option
                    v-for="(employee) in employeeContacts"
                    :key="employee.id"
                    :value="employee.id">
                    {{ employee.profile.lastName }} {{ employee.profile.firstName }}
                  </option>
                </coozzy-form-select>
              </div>
              <div
                v-if="emitting.onSiteContactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_TENANT'"
                class="col-12 mt-3">
                <b-table
                  ref="tenancyContactsTable"
                  :fields="fieldsTenantsList"
                  :items="listContactTenancies"
                  bordered
                  class="overflow-auto shadow"
                  hover
                  responsive="true"
                  select-mode="single"
                  selectable
                  stacked="md">
                  <!-- Busy state -->
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <coozzy-spinner />
                    </div>
                  </template>

                  <!-- Headings -->
                  <template #head(checkbox)>
                    <coozzy-form-checkbox
                      ref="header_checkbox_tenancy_contacts"
                      @change="(value) => { handleCheckboxesInsideTenancyContactsTable(value) }" />
                  </template>
                  <template #head(name)>
                    {{ $t('message.generic.name') }}
                  </template>
                  <template #head(contactPerson)>
                    {{ $t('message.interestedParty.reference.landlord.contactPerson') }}
                  </template>
                  <template #head(type)>
                    {{ $t('message.generic.type') }}
                  </template>
                  <template #head(communication)>
                    {{ $t('message.generic.communication') }}
                  </template>
                  <template #head(action) />

                  <!-- Body -->
                  <template #cell(checkbox)="data">
                    <coozzy-form-checkbox
                      :id="'check_box_' + data.item.id"
                      :initial="selectedTenants.some(t => t.id === data.item.id)"
                      @change="(value) => { tenancyContactSelected(data.item, value) }" />
                  </template>
                  <template #cell(name)="data">
                    {{
                      data.item.name + (isFutureTenant(data.item.id) ? ' ' + $t('message.createOrder.futureTenant') : '')
                    }}
                  </template>
                  <template #cell(contactPerson)="data">
                    <coozzy-form-select
                      v-if="data.item.contactPersons"
                      id="contactPerson"
                      :ref="'contactPerson_' + data.item.id"
                      v-model="data.item.selectedContactPerson"
                      @change="changeTenantContact(data.item)">
                      <option :value="null">
                        -
                      </option>
                      <option
                        v-for="contact of data.item.contactPersons"
                        :key="contact.id"
                        :value="contact.id">
                        {{ contact.name }}
                      </option>
                    </coozzy-form-select>
                    <span v-else>
                      -
                    </span>
                  </template>
                  <template #cell(type)="data">
                    {{ data.item.type }}
                  </template>
                  <template #cell(communication)="data">
                    <div
                      v-if="getPhoneNumbers(data.item.phoneNumbers, 'MOBILE') !== '-'"
                      class="row">
                      <div class="col-1">
                        <coozzy-mobile-alt-icon />
                      </div>
                      <div class="col">
                        <a
                          :href="'tel:' + getPhoneNumbers(data.item.phoneNumbers, 'MOBILE')"
                          class="link">
                          {{ getPhoneNumbers(data.item.phoneNumbers, 'MOBILE') }}
                        </a>
                      </div>
                    </div>
                    <div
                      v-if="getPhoneNumbers(data.item.phoneNumbers, 'HOME') !== '-'"
                      class="row">
                      <div class="col-1">
                        <coozzy-phone-icon />
                      </div>
                      <div class="col">
                        <a
                          :href="'tel:' + getPhoneNumbers(data.item.phoneNumbers, 'HOME')"
                          class="link">
                          {{ getPhoneNumbers(data.item.phoneNumbers, 'HOME') }}
                        </a>
                      </div>
                    </div>
                    <div
                      v-if="getPhoneNumbers(data.item.phoneNumbers, 'WORK') !== '-'"
                      class="row">
                      <div class="col-1">
                        <coozzy-headset-icon />
                      </div>
                      <div class="col">
                        <a
                          :href="'tel:' + getPhoneNumbers(data.item.phoneNumbers, 'WORK')"
                          class="link">
                          {{ getPhoneNumbers(data.item.phoneNumbers, 'WORK') }}
                        </a>
                      </div>
                    </div>
                    <div
                      v-if="getPhoneNumbers(data.item.phoneNumbers, 'FAX') !== '-'"
                      class="row">
                      <div class="col-1">
                        <coozzy-fax-icon />
                      </div>
                      <div class="col">
                        <a
                          :href="'tel:' + getPhoneNumbers(data.item.phoneNumbers, 'FAX')"
                          class="link">
                          {{ getPhoneNumbers(data.item.phoneNumbers, 'FAX') }}
                        </a>
                      </div>
                    </div>
                    <div
                      v-if="data.item.email !== ''"
                      class="row">
                      <div class="col-1">
                        <img
                          alt="Placeholder"
                          class="email-icon-img"
                          src="@/assets/icon/arroba.svg">
                      </div>
                      <div class="col">
                        <template v-if="data.item.email !== ''">
                          <a
                            class="link"
                            tabindex="0"
                            @click="openSendEmailModal(data.item)">
                            {{ data.item.email }}
                          </a>
                        </template>
                        <template v-else>
                          {{ data.item.email | displayOptionalValue }}
                        </template>
                      </div>
                    </div>
                    <div
                      v-if="data.item.website !== ''"
                      class="row">
                      <div class="col-1">
                        <coozzy-globe-icon />
                      </div>
                      <div class="col">
                        <template v-if="data.item.website !== ''">
                          <a
                            :href="getUrlWebsite(data.item.website)"
                            class="link"
                            tabindex="0"
                            target="_blank">
                            {{ data.item.website }}
                          </a>
                        </template>
                        <template v-else>
                          {{ data.item.website | displayOptionalValue }}
                        </template>
                      </div>
                    </div>
                  </template>
                  <template #cell(action)="data">
                    <coozzy-button
                      class=""
                      @click="selectContactToEdit(data.item, 'statusUpdate')">
                      <coozzy-edit-icon-img class="adjustWidth" />
                    </coozzy-button>
                  </template>
                </b-table>
              </div>
              <div
                v-if="emitting.onSiteContactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_CONDO_OWNER'"
                class="col-12 mt-3">
                <coozzy-form-select
                  v-model="selectedCondoOwner"
                  class="select-entries float-right"
                  name="numberEntries">
                  <option value="">
                    -
                  </option>
                  <option
                    v-for="(tenant) in condoOwnersContact"
                    :key="tenant.id"
                    :value="tenant.id">
                    {{
                      getContactName(tenant.id) + (isFutureCondoOwner(tenant.id) ? ' ' + $t('message.createOrder.futureTenant') : '')
                    }}
                  </option>
                </coozzy-form-select>
                <label
                  v-if="listCondoOwnerCompany.length > 0">{{
                  $t('message.createOrder.contactPersonOfCompany')
                }} </label>
                <coozzy-form-select
                  v-if="listCondoOwnerCompany.length > 0"
                  v-model="onSiteContactPersonId"
                  class="select-entries float-right"
                  name="employeeCompany">
                  <option value="">
                    -
                  </option>
                  <option
                    v-for="(tenant) in listCondoOwnerCompany"
                    :key="tenant.id"
                    :value="tenant.id">
                    {{ tenant.name }}
                  </option>
                </coozzy-form-select>
              </div>
              <div
                v-if="emitting.onSiteContactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER'"
                class="col-12 mt-3">
                <coozzy-form-select
                  v-model="selectedUser"
                  class="select-entries float-right"
                  name="numberEntries">
                  <option value="">
                    -
                  </option>
                  <option
                    v-for="(jani) in listJanitors"
                    :key="jani.id"
                    :value="jani.id">
                    {{ getContactName(jani.id) }}
                  </option>
                </coozzy-form-select>
                <label
                  v-if="listEmployeeCompany.length > 0">{{ $t('message.createOrder.contactPersonOfCompany') }} </label>
                <coozzy-form-select
                  v-if="listEmployeeCompany.length > 0"
                  v-model="onSiteContactPersonId"
                  class="select-entries float-right"
                  name="employeeCompany">
                  <option value="">
                    -
                  </option>
                  <option
                    v-for="(jani) in listEmployeeCompany"
                    :key="jani.id"
                    :value="jani.id">
                    {{ jani.name }}
                  </option>
                </coozzy-form-select>
              </div>
              <div
                v-if="emitting.onSiteContactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_SERVICE_PROVIDER'"
                class="col-12 mt-3">
                <coozzy-form-select
                  v-model="selectedServiceProvider"
                  class="select-entries float-right"
                  name="numberEntries">
                  <option value="">
                    -
                  </option>
                  <option
                    v-for="(jani) in serviceProviderContacts"
                    :key="jani.id"
                    :value="jani.id">
                    {{ getContactName(jani.id) }}
                  </option>
                </coozzy-form-select>
                <label
                  v-if="listServiceProviderCompany.length > 0">{{
                  $t('message.createOrder.contactPersonOfCompany')
                }} </label>
                <coozzy-form-select
                  v-if="listServiceProviderCompany.length > 0"
                  v-model="onSiteContactPersonId"
                  class="select-entries float-right"
                  name="employeeCompany">
                  <option value="">
                    -
                  </option>
                  <option
                    v-for="(jani) in listServiceProviderCompany"
                    :key="jani.id"
                    :value="jani.id">
                    {{ jani.name }}
                  </option>
                </coozzy-form-select>
              </div>
              <div
                v-if="emitting.onSiteContactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_CRAFTSMAN'"
                class="col-12 mt-3">
                <coozzy-form-select
                  v-model="selectedCraftsman"
                  class="select-entries float-right"
                  name="numberEntries">
                  <option value="">
                    -
                  </option>
                  <option
                    v-for="(jani) in craftsmanContacts"
                    :key="jani.id"
                    :value="jani.id">
                    {{ getContactName(jani.id) }}
                  </option>
                </coozzy-form-select>
                <label
                  v-if="listCraftsmanCompany.length > 0">{{ $t('message.createOrder.contactPersonOfCompany') }} </label>
                <coozzy-form-select
                  v-if="listCraftsmanCompany.length > 0"
                  v-model="onSiteContactPersonId"
                  class="select-entries float-right"
                  name="employeeCompany">
                  <option value="">
                    -
                  </option>
                  <option
                    v-for="(jani) in listCraftsmanCompany"
                    :key="jani.id"
                    :value="jani.id">
                    {{ jani.name }}
                  </option>
                </coozzy-form-select>
              </div>
              <div
                v-if="emitting.onSiteContactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_DELEGATE'"
                class="col-12 mt-3">
                <coozzy-form-select
                  v-model="selectedDelegate"
                  class="select-entries float-right"
                  name="numberEntries">
                  <option value="">
                    -
                  </option>
                  <option
                    v-for="(delegate) in delegateContacts"
                    :key="delegate.id"
                    :value="delegate.id">
                    {{ getContactName(delegate.id) }}
                  </option>
                </coozzy-form-select>
                <label
                  v-if="listDelegateCompany.length > 0">{{ $t('message.createOrder.contactPersonOfCompany') }} </label>
                <coozzy-form-select
                  v-if="listDelegateCompany.length > 0"
                  v-model="onSiteContactPersonId"
                  class="select-entries float-right"
                  name="employeeCompany">
                  <option value="">
                    -
                  </option>
                  <option
                    v-for="(delegate) in listDelegateCompany"
                    :key="delegate.id"
                    :value="delegate.id">
                    {{ delegate.name }}
                  </option>
                </coozzy-form-select>
              </div>
              <div
                v-if="onSiteContactToShow && emitting.onSiteContactType !== 'VIEWING_APPOINTMENT_CONTACT_TYPE_ASSIGNEE' && emitting.onSiteContactType !== 'VIEWING_APPOINTMENT_CONTACT_TYPE_TENANT'"
                class="col-12">
                <coozzy-alert
                  class="my-2"
                  size="sm"
                  variant="blue">
                  <div>
                    <div
                      class="d-inline-flex float-right">
                      <coozzy-button
                        class=""
                        @click="selectContactToEdit(onSiteContactToShow, 'contactPersonOnsite')">
                        <coozzy-edit-icon class="too-left" />
                      </coozzy-button>
                    </div>
                  </div>
                  <div
                    v-if="onSiteContactToShow"
                    class="">
                    <p
                      class="m-0">
                      <span>{{ onSiteContactToShow.name }}</span>
                    </p>
                    <p
                      v-if="onSiteContactToShow.email"
                      class="m-0">
                      <span>{{ onSiteContactToShow.email }}</span>
                    </p>
                    <p
                      v-if="onSiteContactToShow?.phone"
                      class="m-0">
                      <span>{{ onSiteContactToShow.phone }}</span>
                    </p>
                    <p
                      v-else-if="onSiteContactToShow.phoneNumbers && onSiteContactToShow.phoneNumbers.length > 0"
                      class="m-0">
                      <span
                        v-if="getPhoneNumbers(onSiteContactToShow.phoneNumbers, 'mobile') !== '-'">{{
                          getPhoneNumbers(onSiteContactToShow.phoneNumbers, 'mobile')
                        }}<br></span>
                      <span
                        v-if="getPhoneNumbers(onSiteContactToShow.phoneNumbers, 'home') !== '-'">{{
                        getPhoneNumbers(onSiteContactToShow.phoneNumbers, 'home')
                      }}<br></span>
                    </p>
                  </div>
                </coozzy-alert>
              </div>
            </div>
          </div>
          <div class="col mt-3">
            <coozzy-form-input
              v-model="dates.executeFrom"
              :filter="'formatDate'"
              :name="$tc('message.createOrder.executeFrom')"
              type="date"
              @blur="dateToObject()" />
          </div>
          <div class="col mt-3">
            <coozzy-form-input
              v-model="dates.executeUntil"
              :filter="'formatDate'"
              :name="$tc('message.createOrder.executeUntil') + ' *'"
              :state="$v.emitting.executeUntil.$dirty && $v.emitting.executeUntil.$error ? false : null"
              type="date"
              @blur="dateToObject()" />
          </div>
          <div class="col mt-3">
            <label>{{ $t('message.ticketOverview.ticket.priority.title') }}</label>
            <v-select
              v-model="emitting.priority"
              :clearable="false"
              :options="availablePriority"
              class="v-select-custom"
              label="title">
              <template
                #option="option">
                <img
                  :alt="$tc('message.ticketOverview.ticket.priority.' + option.title)"
                  :src="`/img/priority/prio-${option.title}.svg`"
                  height="15px">
                {{ $t('message.ticketOverview.ticket.priority.' + option.title) }}
              </template>
              <template
                #selected-option="option">
                <div class="selected-option">
                  <img
                    :alt="$tc('message.ticketOverview.ticket.priority.' + option.title)"
                    :src="`/img/priority/prio-${option.title}.svg`"
                    height="15">
                  {{ $t('message.ticketOverview.ticket.priority.' + option.title) }}
                </div>
              </template>
            </v-select>
          </div>
          <div
            class="col-12 mt-3">
            <coozzy-form-input
              v-model="title"
              :name="$t('message.tableColumnHeadings.title') + ' *'"
              :state="$v.title && $v.title.$dirty && $v.title.$error ? false : null" />
          </div>
          <div
            class="col-12 mt-3">
            <label>{{ $t('message.generic.placeholder') }}</label>
            <p class="ml-2 mb-0">
              <span>#anrede# <br></span>
              <span>#eigentuemer# <br></span>
              <span>#eigentuemer.addresse# <br></span>
            </p>
          </div>
          <div class="col-12 mt-3">
            <label>{{ $t('message.settings.template.titleTicket') }}</label>
            <coozzy-form-select
              v-model="selectedTemplate"
              name="numberEntries">
              <option
                value="">
                -
              </option>
              <option
                v-for="template in sortedTemplate"
                :key="template.id"
                :value="template.id">
                {{ template.name }}
              </option>
            </coozzy-form-select>
          </div>
          <div class="col-sm-12 col-md-12 mt-3">
            <coozzy-form-textarea
              ref="orderDescription"
              v-model="emitting.orderDescription"
              :initial="emitting.orderDescription"
              :placeholder="$t('message.createOrder.orderDetails')"
              :rows="20"
              :text="emitting.orderDescription"
              :value-text-area="emitting.orderDescription"
              name="orderDescription">
              {{ $t('message.createOrder.orderDetails') }}
            </coozzy-form-textarea>
          </div>
          <div class="col-12 mt-3">
            <div class="row mb-2">
              <div class="col-12">
                <label for="attachment"> {{ $t('message.ticketOverview.ticket.attachment') }}
                  ({{ filteredMediaList.length }})</label>
                <coozzy-form-file-input
                  id="file"
                  ref="coozzy-file-input"
                  :disabled="uploading"
                  accept="text/plain, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel ,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      ,application/vnd.ms-powerpoint,  application/vnd.openxmlformats-officedocument.presentationml.presentation, application/pdf,   image/*, video/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx .pdf"
                  multiple
                  @change="addFile" />
                <div class="row mt-2 m-0">
                  <div class="col-12 p-0">
                    <div
                      v-if="countDocs > 0"
                      class="row mb-2">
                      <label
                        class="col-12 subtitle"> {{ $t('message.ticketOverview.attachment.document') }} ({{
                          countDocs
                        }})</label>
                      <template
                        v-for="filteredMedia in filteredMediaList">
                        <div
                          v-if="!(['image/jpeg', 'image/png', 'image/gif', 'video/webm', 'video/mp4'].indexOf(filteredMedia.mimeType) !== -1)"
                          :key="filteredMedia.id"
                          class="col-12 square">
                          <div
                            class="file-block">
                            <a
                              :href="filteredMedia.url"
                              tabindex="0"
                              target="_blank">
                              {{ filteredMedia.filename }}
                            </a>
                            <coozzy-button
                              class="delete-icon"
                              design="transparent"
                              @click="deleteMedia($event, filteredMedia.id)">
                              <coozzy-delete-icon />
                            </coozzy-button>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div
                      v-if="countImg > 0"
                      class="row m-0 mb-2">
                      <label class="col-12 p-0 subtitle"> {{ $t('message.ticketOverview.attachment.image') }}
                        ({{ countImg }})</label>
                      <template
                        v-for="filteredMedia in filteredMediaList">
                        <div
                          v-if="['image/jpeg', 'image/png', 'image/gif'].indexOf(filteredMedia.mimeType) !== -1"
                          :key="filteredMedia.id"
                          class="media-block col-2 square">
                          <div
                            :style="{ 'background-image': 'url(' + filteredMedia.url + ')' }"
                            class="uploaded-file w-100"
                            style="background-repeat: no-repeat;background-size: cover;background-position: center center;"
                            @click="imageClicked(filteredMedia)">
                            <coozzy-button
                              class="delete-icon image"
                              design="transparent"
                              @click="deleteMedia($event, filteredMedia.id)">
                              <coozzy-delete-icon />
                            </coozzy-button>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div
                      v-if="countVideo > 0"
                      class="row m-0">
                      <label class="col-12 p-0 subtitle"> {{ $t('message.ticketOverview.attachment.video') }}
                        ({{ countVideo }})</label>
                      <template
                        v-for="filteredMedia in filteredMediaList">
                        <div
                          v-if="['video/webm', 'video/mp4'].indexOf(filteredMedia.mimeType) !== -1"
                          :key="filteredMedia.id"
                          class="media-block col-2 square">
                          <coozzy-thumbnail
                            v-if="getMediaUrl(filteredMedia) !== null"
                            :key="filteredMedia.id"
                            :video-src="getMediaUrl(filteredMedia)"
                            :video-url="filteredMedia.url"
                            class="uploaded-file cursor-pointer"
                            @imageClicked="openVideo(filteredMedia)" />
                          <coozzy-button
                            class="delete-icon video"
                            design="transparent"
                            @click="deleteMedia($event, filteredMedia.id)">
                            <coozzy-delete-icon />
                          </coozzy-button>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </coozzy-card>
      <coozzy-card
        v-if="source === 'device'"
        :title="$t('message.settings.template.titleContract')">
        <template-table
          :default-category="'TEMPLATE_CATEGORY_ORDERS'"
          :source="'tenancy'"
          @selected-contract="itemSelected" />
        <div
          v-if="!isTicketingEnabled"
          class="d-flex justify-content-end mr-4">
          <coozzy-form-checkbox
            :key="Math.random().toString(36).substr(2, 9)"
            v-model="attachAuto"
            :initial="attachAuto"
            class="">
            {{ $t('message.settings.template.addDocumentToDevice') }}
          </coozzy-form-checkbox>
        </div>
      </coozzy-card>
      <!--   Status Updates Card   -->
      <coozzy-card
        :title="$tc('message.createOrder.statusUpdate.title')">
        <div
          class="">
          <p>{{ $tc('message.createOrder.statusUpdate.description') }}</p>
          <div class="row">
            <div class="col-4">
              <coozzy-form-radio
                v-model="sendStatusUpdates"
                :default-model="sendStatusUpdates"
                :select-value="false"
                name="statusUpdates">
                {{ $tc('message.createOrder.statusUpdate.doNotSendStatus') }}
              </coozzy-form-radio>
            </div>
            <div class="col-4">
              <coozzy-form-radio
                v-model="sendStatusUpdates"
                :default-model="sendStatusUpdates"
                :select-value="true"
                name="statusUpdates">
                {{ $tc('message.createOrder.statusUpdate.sendStatus') }}
              </coozzy-form-radio>
            </div>
            <div
              v-if="sendStatusUpdates"
              class="col-4">
              <coozzy-form-checkbox
                v-model="includeCorrespondenceContact">
                {{ $t('message.createOrder.includeCorrespondenceContact') }}
              </coozzy-form-checkbox>
            </div>
          </div>
          <div
            v-if="sendStatusUpdates"
            class="row">
            <div class="col-md-4 col-sm-6 mt-3">
              <coozzy-form-input
                ref="searchInputText"
                v-model="querySearch"
                :placeholder="$t('message.generic.search')"
                @keyup="searchInputText()" />
            </div>
            <div class="col-12 mt-3">
              <b-table
                ref="contactsStatusUpdatesTable"
                :fields="fieldsStatusUpdate"
                :items="filteredStatusUpdatesContacts"
                bordered
                class="overflow-auto shadow"
                hover
                responsive="true"
                select-mode="single"
                selectable
                stacked="md">
                <!-- Busy state -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <coozzy-spinner />
                  </div>
                </template>

                <!-- Headings -->
                <template #head(checkbox)>
                  <coozzy-form-checkbox
                    ref="header_checkbox_status_updates"
                    @change="(value) => { handleCheckboxesInsideStatusUpdatesTable(value) }" />
                </template>
                <template #head(name)>
                  {{ $t('message.generic.name') }}
                </template>
                <template #head(contactPerson)>
                  {{ $t('message.interestedParty.reference.landlord.contactPerson') }}
                </template>
                <template #head(type)>
                  {{ $t('message.generic.type') }}
                </template>
                <template #head(role)>
                  {{ $t('message.generic.role') }}
                </template>
                <template #head(email)>
                  {{ $t('message.generic.email') }}
                </template>
                <template #head(action) />

                <!-- Body -->
                <template #cell(checkbox)="data">
                  <coozzy-form-checkbox
                    :id="'check_' + data.item.id"
                    :initial="checkStatusCheckbox(data.item.id)"
                    @change="(value) => { contactSelected(data.item, value) }" />
                </template>
                <template #cell(name)="data">
                  {{ data.item.name }}
                </template>
                <template #cell(contactPerson)="data">
                  <coozzy-form-select
                    v-if="data.item.contactPersons"
                    id="contactPerson"
                    :ref="'contactPerson_' + data.item.id"
                    v-model="data.item.selectedContactPerson"
                    @change="changeNotifiedEmail(data.item)">
                    <option :value="null">
                      -
                    </option>
                    <option
                      v-for="contact of data.item.contactPersons"
                      :key="contact.id"
                      :value="contact.id">
                      {{ contact.name }}
                    </option>
                  </coozzy-form-select>
                  <span v-else>
                    -
                  </span>
                </template>
                <template #cell(type)="data">
                  {{ data.item.type }}
                </template>
                <template #cell(role)="data">
                  {{ data.item.role }}
                </template>
                <template #cell(email)="data">
                  {{ data.item.email }}
                </template>
                <template #cell(action)="data">
                  <coozzy-button
                    class=""
                    @click="selectContactToEdit(data.item, 'statusUpdate')">
                    <coozzy-edit-icon-img class="adjustWidth" />
                  </coozzy-button>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </coozzy-card>
    </div>
    <b-modal
      v-if="selectedObjectVideo !== ''"
      ref="show-video"
      hide-footer
      hide-header>
      <div class="row mb-2">
        <div class="col">
          <b-embed
            controls
            type="video">
            <source
              :src="selectedObjectVideo"
              type="video/webm">
            <source
              :src="selectedObjectVideo"
              type="video/mp4">
          </b-embed>
        </div>
      </div>
    </b-modal>
    <create-contact-modal
      v-if="contactToEdit"
      :key="contactToEdit.id"
      ref="create-contact-modal"
      :contact-to-edit="contactToEdit"
      :enable-delete="false"
      :for-owner-id="isOwnerModule ? accountId : null"
      :set-interested-party-role="false"
      :show-add-another="false"
      :show-request-sources="false"
      :show-roles-input="false"
      @contact-updated="updateContact" />
    <contact-person-creation
      v-if="selectedPerson"
      :key="selectedPerson ? 'modal-person'+selectedPerson.id : 'modal-person'"
      ref="contact-person-modal"
      :company-contact="contactToEdit"
      :contact-type="typeOfContact"
      :selected-contact="selectedPerson"
      @edit-contact-person="contactPersonEdited" />
  </section>
</template>

<script lang="ts">
import CoozzyFormSelect from '@/framework/components/form/select/CoozzyFormSelect.vue'
import CoozzyFormRadio from '@/framework/components/form/radio/CoozzyFormRadio.vue'
import CoozzyFormInput from '@/framework/components/form/input/CoozzyFormInput.vue'
import CoozzyCard from '@/framework/components/card/CoozzyCard.vue'
import TemplateTable from '@/settings/components/TemplateTable.vue'
import { user } from '@/mixins/user'
import { contact } from '@/mixins/contact'
import { dateUtils } from '@/mixins/dateUtils'
import Vue, { PropType } from 'vue'
import { media } from '@/mixins/media'
import CreateContactModal from '@/contact/components/CreateContactModal.vue'
import ContactPersonCreation from '@/contact/components/ContactPersonCreation.vue'
import { helpers, required } from 'vuelidate/lib/validators'
import CoozzyAlert from '@/framework/components/alert/CoozzyAlert.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import CoozzyEditIcon from '@/framework/components/icons/CoozzyEditIcon.vue'
import CoozzyFormCheckbox from '@/framework/components/form/checkbox/CoozzyFormCheckbox.vue'
import CoozzyFormFileInput from '@/framework/components/form/fileInput/CoozzyFormFileInput.vue'
import CoozzyDeleteIcon from '@/framework/components/icons/CoozzyDeleteIcon.vue'
import CoozzyThumbnail from '@/framework/components/img/CoozzyThumbnail.vue'
import { extractOrderDetailsFromDescription } from '@/misc/utils/orderUtils'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import { tables } from '@/mixins/tables'
import { mapMutations, mapState } from 'vuex'
import MessageApi from '@/misc/apis/MessageApi'
import CoozzyFormTextarea from '@/framework/components/form/textarea/CoozzyFormTextarea.vue'
import CoozzyHeadsetIcon from '@/framework/components/icons/CoozzyHeadsetIcon.vue'
import CoozzyFaxIcon from '@/framework/components/icons/CoozzyFaxIcon.vue'
import CoozzyMobileAltIcon from '@/framework/components/icons/CoozzyMobileAltIcon.vue'
import CoozzyPhoneIcon from '@/framework/components/icons/CoozzyPhoneIcon.vue'
import CoozzyGlobeIcon from '@/framework/components/icons/CoozzyGlobeIcon.vue'
import CoozzyEditIconImg from '@/framework/components/icons/CoozzyEditIconImg.vue'
import MediaApi from '@/misc/apis/MediaApi'
import {
  Contactcontactv2ContactPerson,
  V2PhoneNumber,
  ObjectobjectObject,
  ObjecttenancyTenancy,
  ObjectViewingAppointmentContactType,
  TicketExternalTicketWatcher,
  TicketOnSiteContact,
  TicketTicket,
  TypeDate
} from '@/types/api'
import { Contact } from '@/types/models'

type ReferenceItem = { id: string, relatedIds?: string[] }
type RoomReference = { id: string, referenceId: string }
type RenderReference = { contactId: string, objectId?: string, buildingId?: string, propertyId?: string }
type SimpleOwnerLike = { owner?: { contactIds?: string[] }, startingAt?: TypeDate }
type EmployeeContact = Contact & { profile: { firstName: string, lastName: string } }
type OrderMedia = {
  id: string
  mimeType: string
  url: string
  filename: string
  uploadedAt: string
  thumbnails?: { type: string | number, url: string }[]
}
type StatusUpdateContact = {
  id: string
  name: string
  type: string
  role: string
  email: string
  contactPersons: Contactcontactv2ContactPerson[] | null
  selectedContactPerson?: string | null
}
type TenancyContact = {
  id: string
  name: string
  type: string
  role: string
  email: string
  contactPersons: Contactcontactv2ContactPerson[] | null
  phoneNumbers: V2PhoneNumber[]
  website?: string
  selectedContactPerson?: string | null
}

/**
 * On-site contact type stored on tickets / UI. String literals are kept explicit because TS does not
 * treat every runtime string as assignable to {@link ObjectViewingAppointmentContactType}.
 */
type ExtendedOnSiteContactType =
  | ObjectViewingAppointmentContactType
  | 'VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER'
  | 'VIEWING_APPOINTMENT_CONTACT_TYPE_SERVICE_PROVIDER'
  | 'VIEWING_APPOINTMENT_CONTACT_TYPE_CRAFTSMAN'
  | 'VIEWING_APPOINTMENT_CONTACT_TYPE_DELEGATE'
  | 'VIEWING_APPOINTMENT_CONTACT_TYPE_CONDO_OWNER'

type OnSiteContactToShowRow = (Contact | Contactcontactv2ContactPerson) & { phone?: string }

function greaterThanExecuteFrom(value: TypeDate | null): boolean {
  const untilInput = this.$options.filters.objectToDateInput(value)
  const fromInput = this.$options.filters.objectToDateInput(this.emitting.executeFrom)
  // Treat null / empty / proto sentinels (year 0 or -1) as unset — objectToDateInput returns null/''
  if (!untilInput || !fromInput) {
    return true
  }
  return new Date(untilInput) >= new Date(fromInput)
}

export default Vue.extend({
  name: 'OrderDataTab',
  components: {
    CoozzyEditIconImg,
    CoozzyGlobeIcon,
    CoozzyPhoneIcon,
    CoozzyMobileAltIcon,
    CoozzyFaxIcon,
    CoozzyHeadsetIcon,
    CoozzyFormTextarea,
    CoozzySpinner,
    CoozzyThumbnail,
    CoozzyDeleteIcon,
    CoozzyFormFileInput,
    CoozzyFormCheckbox,
    CoozzyEditIcon,
    CoozzyButton,
    CoozzyAlert,
    TemplateTable,
    CoozzyCard,
    CoozzyFormInput,
    CoozzyFormRadio,
    CoozzyFormSelect,
    CreateContactModal,
    ContactPersonCreation
  },
  mixins: [user, dateUtils, media, contact, tables],
  props: {
    employeeContacts: {
      type: Array as PropType<EmployeeContact[]>,
      required: true
    },
    tenantContacts: {
      type: Array as PropType<Contact[]>,
      required: true
    },
    janitorContacts: {
      type: Array as PropType<Contact[]>,
      required: true
    },
    craftsmanContacts: {
      type: Array as PropType<Contact[]>,
      required: true
    },
    serviceProviderContacts: {
      type: Array as PropType<Contact[]>,
      required: true
    },
    delegateContacts: {
      type: Array as PropType<Contact[]>,
      required: true
    },
    condoOwnersContact: {
      type: Array as PropType<Contact[]>,
      required: true
    },
    ownersList: {
      type: Array as PropType<string[]>,
      required: true
    },
    tenancies: {
      type: Array as PropType<ObjecttenancyTenancy[]>,
      default: () => {
        return []
      }
    },
    condoOwners: {
      type: Array as PropType<SimpleOwnerLike[]>,
      default: () => {
        return []
      }
    },
    source: {
      type: String,
      default: ''
    },
    objects: {
      type: Array as PropType<ObjectobjectObject[]>,
      default: () => {
        return []
      }
    },
    objectReferences: {
      type: Array as PropType<ReferenceItem[]>,
      default: () => {
        return []
      }
    },
    references: {
      type: Array as PropType<ReferenceItem[]>,
      default: () => {
        return []
      }
    },
    operator: {
      type: Object,
      default: null
    },
    rooms: {
      type: Array as PropType<RoomReference[]>,
      default: () => {
        return []
      }
    },
    ticketTitle: {
      type: String,
      default: ''
    },
    linkedTicket: {
      type: Object as PropType<TicketTicket | null>,
      default: null
    },
    descriptionMergeOrders: {
      type: String,
      default: ''
    },
    media: {
      type: Array as PropType<OrderMedia[]>,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      emitting: {
        selectedEmployee: '',
        onSiteContactType: ObjectViewingAppointmentContactType.VIEWING_APPOINTMENT_CONTACT_TYPE_ASSIGNEE as ExtendedOnSiteContactType,
        onSiteContactPersonIds: [] as string[],
        contact: {
          firstName: '',
          lastName: '',
          email: '',
          phone: ''
        },
        executeFrom: null as TypeDate | null,
        executeUntil: null as TypeDate | null,
        orderDescription: '',
        selectedContracts: '',
        priority: 'DEFAULT'
      },
      dates: {
        executeFrom: null as string | null,
        executeUntil: null as string | null
      },
      selectedUser: '' as string,
      selectedTenants: [] as TenancyContact[],
      selectedCondoOwner: '' as string,
      selectedCraftsman: '' as string,
      selectedServiceProvider: '' as string,
      selectedDelegate: '' as string,
      listEmployeeCompany: [] as EmployeeContact[],
      listCondoOwnerCompany: [] as Contact[],
      listCraftsmanCompany: [] as Contact[],
      listServiceProviderCompany: [] as Contact[],
      listDelegateCompany: [] as Contact[],
      listJanitors: [] as Contact[],
      attachAuto: false as boolean,
      mediasList: [] as OrderMedia[],
      countDocs: 0 as number,
      countImg: 0 as number,
      countVideo: 0 as number,
      attachment: [] as File[],
      uploading: false as boolean,
      selectedObjectVideo: '' as string,
      galleryImages: [] as string[],
      onSiteContactToShow: null as OnSiteContactToShowRow | null,
      contactToEdit: null as Contact | null,
      selectedPerson: null as Contact | Contactcontactv2ContactPerson | null,
      typeOfContact: null as string | null,
      includeCorrespondenceContact: false as boolean,
      title: '' as string,
      availablePriority: ['LOW', 'DEFAULT', 'HIGH'] as string[],
      sendStatusUpdates: false as boolean,
      statusUpdatesContacts: [] as StatusUpdateContact[],
      filteredStatusUpdatesContacts: [] as StatusUpdateContact[],
      fieldsStatusUpdate: [
        {
          key: 'checkbox',
          label: '',
          thClass: 'th-checkbox',
          tdClass: 'align-middle border-right-0 checkbox-cell'
        },
        {
          key: 'name',
          label: this.$t('message.generic.name'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'contactPerson',
          label: this.$t('message.interestedParty.reference.landlord.contactPerson'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'type',
          label: this.$t('message.generic.type'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'role',
          label: this.$t('message.generic.role'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'email',
          label: this.$t('message.generic.email'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'action',
          label: '',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        }
      ],
      fieldsTenantsList: [
        {
          key: 'checkbox',
          label: '',
          thClass: 'th-checkbox',
          tdClass: 'align-middle border-right-0 checkbox-cell'
        },
        {
          key: 'name',
          label: this.$t('message.generic.name'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'contactPerson',
          label: this.$t('message.interestedParty.reference.landlord.contactPerson'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'type',
          label: this.$t('message.generic.type'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'communication',
          label: this.$t('message.generic.communication'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'action',
          label: '',
          thClass: 'align-middle',
          tdClass: 'align-middle'
        }
      ],
      selectedContactsUpdatesStatus: [] as string[],
      querySearch: '' as string,
      selectedTemplate: '' as string,
      listContactTenancies: [] as TenancyContact[],
      onSiteContactPersonId: '' as string,
      pendingLinkedTicketContact: null as TicketOnSiteContact | null,
      pendingLinkedTicketContactType: null as ObjectViewingAppointmentContactType | null,
      pendingLinkedTicketTenantContactIds: [] as string[],
      pendingDraftStatusUpdateWatchers: null as TicketExternalTicketWatcher[] | null
    }
  },
  computed: {
    ...mapState('message', ['templates']),
    sortedTemplate() {
      return this.templates.filter(x => x.type === 'TEMPLATE_TYPE_TICKET').slice().sort((a, b) => {
        if (a.name > b.name) {
          return 1
        }
        if (b.name > a.name) {
          return -1
        }
        return 0
      })
    },
    combinedContacts() {
      return [
        ...this.tenantContacts,
        ...this.janitorContacts,
        ...this.craftsmanContacts,
        ...this.serviceProviderContacts,
        ...this.condoOwnersContact,
        ...this.delegateContacts
      ]
    },
    filteredMediaList() {
      const array = this.mediasList
      array.sort((val1, val2) => {
        return parseInt(val2.uploadedAt) - parseInt(val1.uploadedAt)
      })
      if (array.length > 0) {
        array.forEach(element => {
          if (!(['image/jpeg', 'image/png', 'image/gif', 'video/webm', 'video/mp4'].indexOf(element.mimeType) !== -1)) {
            this.countDocs = this.countDocs + 1
          }
          if (['image/jpeg', 'image/png', 'image/gif'].indexOf(element.mimeType) !== -1) {
            this.countImg = this.countImg + 1
          }
          if (['video/webm', 'video/mp4'].indexOf(element.mimeType) !== -1) {
            this.countVideo = this.countVideo + 1
          }
        })
      }
      return array
    }
  },
  watch: {
    descriptionMergeOrders: {
      immediate: true,
      handler: function (newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.emitting.orderDescription = newValue
        }
      }
    },
    selectedTemplate: {
      deep: true,
      handler: async function (val) {
        if (val !== '') {
          const template = this.sortedTemplate.find(x => x.id === val)
          const list = []
          if (this.objectReferences.length > 0) {
            this.objectReferences.forEach(element => {
              if (element.id.startsWith('building')) {
                list.push({
                  contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : '',
                  buildingId: element.id
                })
              } else if (element.id.startsWith('prop')) {
                list.push({
                  contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : '',
                  propertyId: element.id
                })
              } else if (element.id.startsWith('device') || element.id.startsWith('tenancy')) {
                const objectId = element.relatedIds?.find(item => item.startsWith('obj'))
                const buildingId = element.relatedIds?.find(item => item.startsWith('building'))
                const propertyId = element.relatedIds?.find(item => item.startsWith('prop'))
                const reference: RenderReference = {
                  contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : ''
                }
                if (objectId) {
                  reference.objectId = objectId
                } else if (buildingId) {
                  reference.buildingId = buildingId
                } else if (propertyId) {
                  reference.propertyId = propertyId
                }
                list.push(reference)
              } else if (element.id.startsWith('room') && this.rooms.length > 0) {
                const room = this.rooms.find(x => x.id === element.id)
                if (room?.referenceId.startsWith('building')) {
                  list.push({
                    contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : '',
                    buildingId: room.referenceId
                  })
                }
                if (room?.referenceId.startsWith('obj')) {
                  list.push({
                    contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : '',
                    objectId: room.referenceId
                  })
                }
              } else {
                list.push({
                  contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : '',
                  objectId: element.id
                })
              }
            })
          } else if (this.references.length > 0) {
            this.references.forEach(element => {
              if (element.id.startsWith('obj')) {
                let objectId = element.id.startsWith('obj') ? element.id : element.relatedIds.find(item => item.startsWith('obj'))
                list.push({
                  contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : '',
                  objectId: objectId
                })
              }
              if (element.id.startsWith('building')) {
                list.push({
                  contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : '',
                  buildingId: element.id
                })
              }
              if (element.id.startsWith('prop')) {
                list.push({
                  contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : '',
                  propertyId: element.id
                })
              }
              if (element.id.startsWith('device') || element.id.startsWith('tenancy')) {
                const objectId = element.relatedIds?.find(item => item.startsWith('obj'))
                const buildingId = element.relatedIds?.find(item => item.startsWith('building'))
                const propertyId = element.relatedIds?.find(item => item.startsWith('prop'))
                const reference: RenderReference = {
                  contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : ''
                }
                if (objectId) {
                  reference.objectId = objectId
                } else if (buildingId) {
                  reference.buildingId = buildingId
                } else if (propertyId) {
                  reference.propertyId = propertyId
                }
                list.push(reference)
              }
              if (element.id.startsWith('room') && this.rooms.length > 0) {
                const room = this.rooms.find(x => x.id === element.id)
                if (room?.referenceId.startsWith('building')) {
                  list.push({
                    contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : '',
                    buildingId: room.referenceId
                  })
                }
                if (room?.referenceId.startsWith('obj')) {
                  list.push({
                    contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : '',
                    objectId: room.referenceId
                  })
                }
              }
            })
          } else if (this.operator) {
            list.push({
              contactId: this.operator ? ('id' in this.operator ? this.operator.id : this.operator.objectID) : ''
            })
          }
          this.emitting.orderDescription = ''
          if (list.length > 0 && (template.message.includes('#anrede#') || template.message.includes('#eigentuemer#') || template.message.includes('#eigentuemer.addresse#'))) {
            await MessageApi.bulkRenderText(list, template.message, '').then(response => {
              if (response?.entries.length > 0) {
                response?.entries.forEach(element => {
                  if (element?.text && !this.emitting.orderDescription.includes(element.text)) {
                    this.emitting.orderDescription += element.text + '\n\n' + this.descriptionMergeOrders
                  }
                })
              }
            })
          } else {
            this.emitting.orderDescription = template.message + '\n\n' + this.descriptionMergeOrders + '\n'
          }
        } else {
          this.emitting.orderDescription = this.descriptionMergeOrders
        }
      }
    },
    attachAuto: {
      deep: true,
      handler: function (val) {
        this.$emit('update-attach-auto', val)
      }
    },
    emitting: {
      deep: true,
      handler: function () {
        this.$emit('updated', this.emitting)
      }
    },
    dates: {
      deep: true,
      handler: function () {
        this.$v.$reset()
      }
    },
    onSiteContactPersonId: {
      deep: true,
      handler: function (value) {
        if (value !== '') {
          this.emitting.onSiteContactPersonIds = [value]
          this.combinedContacts.forEach((element) => {
            if (element.id === value) {
              this.onSiteContactToShow = element
              // this.contactToEdit = element
            } else if ('contactPersons' in element && element.contactPersons?.length > 0) {
              element.contactPersons.forEach((contact) => {
                if (contact.id === value) {
                  this.onSiteContactToShow = contact
                  this.selectedPerson = contact
                }
              })
            }
          })
        } else {
          if (this.emitting.onSiteContactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER') {
            if (this.selectedUser !== '') {
              this.onSiteContactPersonId = this.selectedUser
            }
          }
          if (this.emitting.onSiteContactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_SERVICE_PROVIDER') {
            if (this.selectedServiceProvider !== '') {
              this.onSiteContactPersonId = this.selectedServiceProvider
            }
          }
          if (this.emitting.onSiteContactType === 'VIEWING_APPOINTMENT_CONTACT_TYPE_CRAFTSMAN') {
            if (this.selectedCraftsman !== '') {
              this.onSiteContactPersonId = this.selectedCraftsman
            }
          }
        }
      }
    },
    selectedUser: function (value) {
      if (value !== '') {
        const item = this.janitorContacts.find(x => x.id === value)
        this.onSiteContactToShow = this.combinedContacts.filter(x => x.id === value)[0]
        if (item && !('contactPersons' in item)) {
          this.onSiteContactPersonId = value
          this.listEmployeeCompany = []
        } else {
          if (item && item.contactPersons.length > 0) {
            this.onSiteContactPersonId = value
            this.listEmployeeCompany = item.contactPersons
          } else {
            this.onSiteContactPersonId = value
            this.listEmployeeCompany = []
          }
        }
      } else {
        this.onSiteContactToShow = null
        this.onSiteContactPersonId = ''
        this.listEmployeeCompany = []
      }
    },
    selectedTenants: function (value) {
      const ids = []
      value.forEach(contact => {
        this.listContactTenancies.forEach(tenancy => {
          if (tenancy.id === contact.id && !tenancy.selectedContactPerson) {
            ids.push(tenancy.id)
          } else if (tenancy.id === contact.id && tenancy.selectedContactPerson) {
            ids.push(tenancy.selectedContactPerson)
          }
        })
      })
      this.emitting.onSiteContactPersonIds = ids
    },
    selectedCondoOwner: function (value) {
      if (value !== '') {
        const item = this.condoOwnersContact.find(x => x.id === value)
        this.onSiteContactToShow = this.combinedContacts.filter(x => x.id === value)[0]
        if (item && !('contactPersons' in item)) {
          this.onSiteContactPersonId = value
          this.listCondoOwnerCompany = []
        } else {
          if (item && item.contactPersons.length > 0) {
            this.onSiteContactPersonId = value
            this.listCondoOwnerCompany = item.contactPersons
          } else {
            this.onSiteContactPersonId = value
            this.listCondoOwnerCompany = []
          }
        }
      } else {
        this.onSiteContactToShow = null
        this.onSiteContactPersonId = ''
        this.listCondoOwnerCompany = []
      }
    },
    selectedCraftsman: function (value) {
      if (value !== '') {
        const item = this.craftsmanContacts.find(x => x.id === value)
        this.onSiteContactToShow = this.combinedContacts.filter(x => x.id === value)[0]
        if (item && !('contactPersons' in item)) {
          this.onSiteContactPersonId = value
          this.listCraftsmanCompany = []
        } else {
          if (item && item.contactPersons.length > 0) {
            this.onSiteContactPersonId = value
            this.listCraftsmanCompany = item.contactPersons
          } else {
            this.onSiteContactPersonId = value
            this.listCraftsmanCompany = []
          }
        }
      } else {
        this.onSiteContactToShow = null
        this.onSiteContactPersonId = ''
        this.listCraftsmanCompany = []
      }
    },
    selectedServiceProvider: function (value) {
      if (value !== '') {
        const item = this.serviceProviderContacts.find(x => x.id === value)
        this.onSiteContactToShow = this.combinedContacts.filter(x => x.id === value)[0]
        if (item && !('contactPersons' in item)) {
          this.onSiteContactPersonId = value
          this.listServiceProviderCompany = []
        } else {
          if (item && item.contactPersons.length > 0) {
            this.onSiteContactPersonId = value
            this.listServiceProviderCompany = item.contactPersons
          } else {
            this.onSiteContactPersonId = value
            this.listServiceProviderCompany = []
          }
        }
      } else {
        this.onSiteContactToShow = null
        this.onSiteContactPersonId = ''
        this.listServiceProviderCompany = []
      }
    },
    selectedDelegate: function(value) {
      if (value !== '') {
        const item = this.delegateContacts.find(x => x.id === value)
        this.onSiteContactToShow = this.combinedContacts.filter(x => x.id === value)[0]
        if (item && !('contactPersons' in item)) {
          this.onSiteContactPersonId = value
          this.listDelegateCompany = []
        } else {
          if (item && item.contactPersons.length > 0) {
            this.onSiteContactPersonId = value
            this.listDelegateCompany = item.contactPersons
          } else {
            this.onSiteContactPersonId = value
            this.listDelegateCompany = []
          }
        }
      } else {
        this.onSiteContactToShow = null
        this.onSiteContactPersonId = ''
        this.listDelegateCompany = []
      }
    },
    'emitting.onSiteContactType': function () {
      this.onSiteContactToShow = null
      this.includeCorrespondenceContact = false

      // reset all selected contacts in different type
      this.selectedUser = ''
      this.selectedTenants = []
      this.selectedCondoOwner = ''
      this.selectedCraftsman = ''
      this.selectedServiceProvider = ''
      this.selectedDelegate = ''
    },
    janitorContacts: function () {
      this.listJanitors = this.janitorContacts.filter(x => x.types && x.types.includes('CARETAKER'))
    },
    employeeContacts: function () {
      this.resolveLinkedTicketContact()
    },
    combinedContacts: function () {
      this.resolveLinkedTicketContact()
      const contacts = this.tenantContacts.concat(this.janitorContacts).concat(this.craftsmanContacts).concat(this.serviceProviderContacts).concat(this.condoOwnersContact)
      if (this.statusUpdatesContacts.length === 0 || contacts.length !== this.statusUpdatesContacts.length) {
        this.loadStatusUpdatesContacts()
        this.loadTenanciesContacts()
      } else {
        this.editStatusUpdatesContacts()
        this.editTenancyContacts()
      }
      this.resolveDraftStatusUpdateWatchers()
    },
    listContactTenancies: function (val) {
      if (val.length > 0 && this.pendingLinkedTicketTenantContactIds.length > 0) {
        this.pendingLinkedTicketTenantContactIds.forEach(id => {
          const contact = val.find(x => x.id === id)
          if (contact) {
            this.tenancyContactSelected(contact, true)
          }
        })
        this.pendingLinkedTicketTenantContactIds = []
      }
    },
    selectedContactsUpdatesStatus: function (value) {
      if (value.length === 0) {
        this.handleCheckboxesInsideStatusUpdatesTable(false)
      }
      const contacts = this.statusUpdatesContacts.filter(x => value.includes(x.id))
      this.$emit('update-status-contact', contacts)
    },
    sendStatusUpdates: function (value) {
      if (value === false) {
        this.selectedContactsUpdatesStatus = []
      }
      const contacts = this.statusUpdatesContacts.filter(x => this.selectedContactsUpdatesStatus.includes(x.id))
      this.$emit('update-status-contact', contacts)
    },
    filteredStatusUpdatesContacts: function () {
      this.filteredStatusUpdatesContacts.forEach((element) => {
        const j = this.statusUpdatesContacts.findIndex(x => x.id === element.id)
        if (j !== -1) {
          this.statusUpdatesContacts[j] = element
        }
      })
    },
    ticketTitle: {
      immediate: true,
      handler(value) {
        this.title = value
      }
    },
    operator: {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadStatusUpdatesContacts()
        }
      }
    },
    linkedTicket: {
      immediate: true,
      handler(value) {
        if (value) {
          this.title = value.title
          if (value.status === 'TICKET_STATUS_DRAFT') {
            if (value.description) {
              this.emitting.orderDescription = extractOrderDetailsFromDescription(
                value.description,
                this.$t('message.createOrder.orderDetails')
              )
            }
            if (value.priority) {
              this.emitting.priority = value.priority
            }
            if (value.startDate && value.startDate.year > 0) {
              this.emitting.executeFrom = value.startDate
              this.dates.executeFrom = this.$options.filters.objectToDateInput(value.startDate)
            }
            if (value.dueDate && value.dueDate.year > 0) {
              this.emitting.executeUntil = value.dueDate
              this.dates.executeUntil = this.$options.filters.objectToDateInput(value.dueDate)
            }
            if (value.onSiteContacts?.length > 0) {
              const contactIds = value.onSiteContacts.map(c => c.contactId).filter(Boolean)
              this.emitting.onSiteContactPersonIds = contactIds
              if (value.onSiteContacts[0]) {
                const storedTypeEntry = value.additionalData?.find(d => d.key === 'onSiteContactType')
                this.pendingLinkedTicketContactType = storedTypeEntry?.value || null
                this.pendingLinkedTicketContact = value.onSiteContacts[0]
                this.resolveLinkedTicketContact()
              }
            }
            const a = value.assignee
            if (a && (a.userId || a.email)) {
              let assigneeEmployee = a.userId
                ? this.employeeContacts.find(e => e.id === a.userId)
                : null
              if (!assigneeEmployee && a.email) {
                assigneeEmployee = this.employeeContacts.find(e => e.email === a.email)
              }
              if (assigneeEmployee) {
                this.emitting.selectedEmployee = assigneeEmployee.id
              }
            }
            const sendStatusEntry = value.additionalData?.find(d => d.key === 'sendStatusUpdates')
            const statusWatchers = value.externalTicketWatchers?.filter(w => w.notifyOnlyStatusChanges) || []
            if (sendStatusEntry?.value === 'true' || statusWatchers.length > 0) {
              this.sendStatusUpdates = true
              if (statusWatchers.length > 0) {
                this.pendingDraftStatusUpdateWatchers = statusWatchers
                this.resolveDraftStatusUpdateWatchers()
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    const currentEmployee = this.employeeContacts.find(e => e.email?.toLowerCase() === this.userEmail?.toLowerCase())
    if (currentEmployee) {
      const isDraft = this.linkedTicket?.status === 'TICKET_STATUS_DRAFT'
      if (!isDraft || !this.emitting.selectedEmployee) {
        this.emitting.selectedEmployee = currentEmployee.id
      }
    }
    this.emitting.executeFrom = this.toObject(new Date())
    this.dates.executeFrom = this.$options.filters.objectToDateInput(this.emitting.executeFrom)
    if (this.janitorContacts.length > 0) {
      this.listJanitors = this.janitorContacts.filter(x => x.types && x.types.includes('CARETAKER'))
    }
    this.loadStatusUpdatesContacts()
    this.loadTenanciesContacts()
    this.mediasList = this.media
  },
  methods: {
    ...mapMutations('message', [
      'setSendMailContacts',
      'setSendMailPreselectedContact',
      'setSendMailReferenceIds',
      'setSendMailEmailToReply',
      'setToAllTo'
    ]),
    sendEmailModal(contact: Contact | Contactcontactv2ContactPerson) {
      this.setSendMailContacts([contact])
      this.setSendMailPreselectedContact(contact)
      this.setSendMailReferenceIds([])
      this.setSendMailEmailToReply(null)
      this.$nextTick(() => {
        this.callShowSendMailModal()
      })
    },
    callShowSendMailModal(setToAllTo = false) {
      this.setToAllTo(setToAllTo)
      if (this.$store.getters['user/isDetailMailModalOpen'] === true) {
        return
      }
      if (this.$store.getters['user/isSendMailModalOpen'] === false) {
        this.$bvModal.show('modal-send-mail')
      } else {
        this.$bvModal.show('draft-writing-email-modal')
      }
    },
    resolveLinkedTicketContact() {
      const pending = this.pendingLinkedTicketContact
      if (!pending) return

      const contactId = pending.contactId
      const email = pending.email
      const storedType = this.pendingLinkedTicketContactType

      if (!contactId && !email) return

      const resolveWithType = (type: ExtendedOnSiteContactType, setContactFn: () => void) => {
        this.emitting.onSiteContactType = type
        this.pendingLinkedTicketContact = null
        this.pendingLinkedTicketContactType = null
        this.$nextTick(setContactFn)
      }

      // for all list-based types: finds by direct ID or sub-contact person ID.
      const tryBuildingContact = (contactsList: Contact[], type: ExtendedOnSiteContactType, setter: (id: string) => void): boolean => {
        if (!contactId) return false
        const c = contactsList.find(c => c.id === contactId || c.contactPersons?.some(cp => cp.id === contactId))
        if (!c) return false
        resolveWithType(type, () => {
          setter(c.id)
          if (c.id !== contactId) this.$nextTick(() => { this.onSiteContactPersonId = contactId })
        })
        return true
      }

      const tryCaretaker = () => tryBuildingContact(this.janitorContacts, 'VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER', id => { this.selectedUser = id })
      const tryCraftsman = () => tryBuildingContact(this.craftsmanContacts, 'VIEWING_APPOINTMENT_CONTACT_TYPE_CRAFTSMAN', id => { this.selectedCraftsman = id })
      const tryServiceProvider = () => tryBuildingContact(this.serviceProviderContacts, 'VIEWING_APPOINTMENT_CONTACT_TYPE_SERVICE_PROVIDER', id => { this.selectedServiceProvider = id })
      const tryDelegate = () => tryBuildingContact(this.delegateContacts, 'VIEWING_APPOINTMENT_CONTACT_TYPE_DELEGATE', id => { this.selectedDelegate = id })
      const tryCondoOwner = () => tryBuildingContact(this.condoOwnersContact, 'VIEWING_APPOINTMENT_CONTACT_TYPE_CONDO_OWNER', id => { this.selectedCondoOwner = id })

      // handles edge case for tenant, where the contactId must be an id from tenantContacts.
      const tryTenant = () => {
        if (!contactId) return false
        const c = this.tenantContacts.find(x => x.id === contactId)
        if (!c) return false
        this.pendingLinkedTicketContact = null
        this.pendingLinkedTicketContactType = null
        this.pendingLinkedTicketTenantContactIds = this.emitting.onSiteContactPersonIds.slice()
        this.$nextTick(() => {
          this.emitting.onSiteContactType = ObjectViewingAppointmentContactType.VIEWING_APPOINTMENT_CONTACT_TYPE_TENANT
        })
        return true
      }

      // handles assignee (employee contact) mapping by email.
      const tryAssignee = () => {
        if (!email) return false
        const c = this.employeeContacts.find(x => x.email === email)
        if (!c) return false
        this.pendingLinkedTicketContact = null
        this.pendingLinkedTicketContactType = null
        this.onSiteContactPersonId = c.id
        return true
      }

      // PATH 1: type stored in additionalData (order drafts saved via createTickets()).
      if (storedType) {
        switch (storedType) {
          case 'VIEWING_APPOINTMENT_CONTACT_TYPE_ASSIGNEE': tryAssignee(); break
          case 'VIEWING_APPOINTMENT_CONTACT_TYPE_CARETAKER': tryCaretaker(); break
          case 'VIEWING_APPOINTMENT_CONTACT_TYPE_CRAFTSMAN': tryCraftsman(); break
          case 'VIEWING_APPOINTMENT_CONTACT_TYPE_SERVICE_PROVIDER': tryServiceProvider(); break
          case 'VIEWING_APPOINTMENT_CONTACT_TYPE_DELEGATE': tryDelegate(); break
          case 'VIEWING_APPOINTMENT_CONTACT_TYPE_CONDO_OWNER': tryCondoOwner(); break
          case 'VIEWING_APPOINTMENT_CONTACT_TYPE_TENANT': tryTenant(); break
        }
        return
      }

      // PATH 2: no storedType (legacy drafts) — covers existing tickets and old drafts.
      tryCaretaker() || tryCraftsman() || tryServiceProvider() ||
        tryDelegate() || tryCondoOwner() || tryTenant() || tryAssignee()
    },
    resolveDraftStatusUpdateWatchers() {
      const watchers = this.pendingDraftStatusUpdateWatchers
      if (!watchers?.length || this.statusUpdatesContacts.length === 0) {
        return
      }
      const selectedIds: string[] = []
      watchers.forEach(watcher => {
        if (!watcher.contactId) {
          return
        }
        const directMatch = this.statusUpdatesContacts.find(c => c.id === watcher.contactId)
        if (directMatch) {
          selectedIds.push(directMatch.id)
          return
        }
        const parentMatch = this.statusUpdatesContacts.find(c =>
          c.contactPersons?.some(cp => cp.id === watcher.contactId)
        )
        if (parentMatch) {
          selectedIds.push(parentMatch.id)
          const filtered = this.filteredStatusUpdatesContacts.find(c => c.id === parentMatch.id)
          const statusContact = this.statusUpdatesContacts.find(c => c.id === parentMatch.id)
          if (filtered) {
            filtered.selectedContactPerson = watcher.contactId
          }
          if (statusContact) {
            statusContact.selectedContactPerson = watcher.contactId
          }
        }
      })
      this.selectedContactsUpdatesStatus = [...new Set(selectedIds)]
      if (watchers[0]) {
        this.includeCorrespondenceContact = watchers[0].includeCorrespondenceContact || false
      }
      this.pendingDraftStatusUpdateWatchers = null
      const contacts = this.statusUpdatesContacts.filter(x => this.selectedContactsUpdatesStatus.includes(x.id))
      this.$emit('update-status-contact', contacts)
    },
    getUrlWebsite(item: string): string {
      if (item.indexOf('//') > -1) {
        return item
      } else {
        return '//' + item
      }
    },
    getPhoneNumbers(phoneNumbers: V2PhoneNumber[], type: string): string {
      if (phoneNumbers && phoneNumbers.length > 0) {
        if (phoneNumbers.find(element => element.type?.toLowerCase() === type?.toLowerCase())) {
          return phoneNumbers.find(element => element.type.toLowerCase() === type.toLowerCase()).number
        }
      }
      return '-'
    },
    openSendEmailModal(item: Contact | Contactcontactv2ContactPerson) {
      this.sendEmailModal(item)
    },
    filterActiveContactPersons(contact: Contact): Contactcontactv2ContactPerson[] | null {
      if (!('contactPersons' in contact) || !contact.contactPersons?.length) {
        return null
      }
      const activeContactPersons = contact.contactPersons.filter(cp => cp.active !== false)
      return activeContactPersons.length > 0 ? activeContactPersons : null
    },
    checkStatusCheckbox(id: string): boolean {
      return this.selectedContactsUpdatesStatus.includes(id)
    },
    resolveStatusUpdateContactEmail(contact: StatusUpdateContact): string {
      if (contact.selectedContactPerson && contact.contactPersons?.length) {
        const contactPerson = contact.contactPersons.find(cp => cp.id === contact.selectedContactPerson)
        if (contactPerson?.email) {
          return contactPerson.email
        }
      }
      const companyContact = this.combinedContacts.find(c => c.id === contact.id)
      return companyContact?.email || ''
    },
    syncStatusUpdateContactRow(contact: StatusUpdateContact) {
      const email = this.resolveStatusUpdateContactEmail(contact)
      const filteredContact = this.filteredStatusUpdatesContacts.find(x => x.id === contact.id)
      if (filteredContact) {
        filteredContact.selectedContactPerson = contact.selectedContactPerson ?? null
        filteredContact.email = email
      }
      const statusContact = this.statusUpdatesContacts.find(x => x.id === contact.id)
      if (statusContact) {
        statusContact.selectedContactPerson = contact.selectedContactPerson ?? null
        statusContact.email = email
      }
    },
    emitSelectedStatusUpdateContacts() {
      const contacts = this.statusUpdatesContacts.filter(x => this.selectedContactsUpdatesStatus.includes(x.id))
      this.$emit('update-status-contact', contacts)
    },
    changeNotifiedEmail(contact: StatusUpdateContact) {
      this.syncStatusUpdateContactRow(contact)
      if (this.selectedContactsUpdatesStatus.includes(contact.id)) {
        this.emitSelectedStatusUpdateContacts()
      }
    },
    changeTenantContact(contact: TenancyContact) {
      if (contact.selectedContactPerson) {
        this.listContactTenancies.forEach(x => {
          if (x.contactPersons && x.contactPersons.length > 0) {
            const contactPerson = x.contactPersons.find(item => item.id === contact.selectedContactPerson)
            if (contactPerson) {
              x.email = contactPerson.email
              x.phoneNumbers = contactPerson.phoneNumbers.length > 0 ? contactPerson.phoneNumbers : x.phoneNumbers
            }
          }
        })
        if (this.selectedTenants.some(t => t.id === contact.id)) {
          this.selectedTenants = this.selectedTenants.filter(x => x.id !== contact.id)
          const updatedContact = this.listContactTenancies.find(x => x.id === contact.id)
          if (updatedContact) {
            this.selectedTenants.push(updatedContact)
          }
        }
      } else {
        this.listContactTenancies.forEach(x => {
          if (x.id === contact.id) {
            const item = this.combinedContacts.find(item => item.id === contact.id)
            if (item) {
              x.email = item.email
              x.phoneNumbers = item.phoneNumbers
            }
          }
        })
        if (this.selectedTenants.some(t => t.id === contact.id)) {
          this.selectedTenants = this.selectedTenants.filter(x => x.id !== contact.id)
          const updatedContact = this.listContactTenancies.find(x => x.id === contact.id)
          if (updatedContact) {
            this.selectedTenants.push(updatedContact)
          }
        }
      }
    },
    contactPersonEdited(item: Contactcontactv2ContactPerson) {
      for (let index = 0; index < this.contactToEdit.contactPersons.length; index++) {
        if (this.contactToEdit.contactPersons[index].id === item.id) {
          this.contactToEdit.contactPersons[index] = item
          this.onSiteContactToShow = item
          this.selectedPerson = item

          const i = this.combinedContacts.findIndex(x => x.id === this.contactToEdit.id)
          if (i !== -1) {
            this.combinedContacts[i].contactPersons[index] = item
          }

          this.$emit('contact-updated', this.contactToEdit)
          break
        }
      }
    },
    showPerson() {
      if (!('contactPersons' in this.selectedPerson)) {
        this.typeOfContact = 'person'
      } else if (('contactPersons' in this.selectedPerson)) {
        this.typeOfContact = 'company'
      }
      this.$nextTick(function () {
        this.$refs['contact-person-modal'].show()
      })
    },
    updateContact(data: { contact: Contact }) {
      if (data.contact && this.contactToEdit.id === data.contact.id) {
        this.onSiteContactToShow = data.contact

        const index = this.combinedContacts.findIndex(x => x.id === data.contact.id)
        if (index !== -1) {
          this.combinedContacts[index] = data.contact
        }

        this.$emit('contact-updated', data.contact)
      }
    },
    editContactClicked(from: string) {
      if (this.contactToEdit.id === this.onSiteContactToShow?.id || from === 'statusUpdate') {
        this.$refs['create-contact-modal'].show()
      } else {
        this.showPerson()
      }
    },
    imageClicked(item: OrderMedia) {
      if (item.url && item.url !== '') {
        this.galleryImages = [
          item.url
        ]
        this.$nextTick(function () {
          this.$viewerApi({
            images: this.galleryImages,
            options: this.viewerOptions
          })
        })
      }
    },
    openVideo(media: OrderMedia) {
      this.selectedObjectVideo = media.url
      this.$nextTick(() => {
        this.$refs['show-video'].show()
      })
    },
    getMediaUrl(media: OrderMedia): string | null {
      if (media.thumbnails === undefined || media.thumbnails === null || typeof media.thumbnails === 'undefined') {
        return null
      }
      for (const thumbnail of media.thumbnails) {
        if (thumbnail.type === 1 || thumbnail.type === 'M') {
          return thumbnail.url
        }
      }
      return media.url
    },
    async addFile(event) {
      if (event && event.dataTransfer && event.dataTransfer.getData('itemId')) {
        MediaApi.getMediaByID(event.dataTransfer.getData('itemId'))
          .then(response => {
            // this.attachment.push(response.media)
            this.mediasList.push(response.media)
          })
          .catch(e => {
            console.log(e)
            Vue.toasted.show(this.$t('message.loadingErrors.media'), { type: 'error' })
          })
      } else {
        this.attachment = await this.getFilesFromEvent(event)
        if (this.attachment && this.attachment.length > 0) {
          await this.sendFile()
          this.$store.dispatch('user/setChangedModal', true).then().catch(e => console.log(e))
        }
      }
    },
    async sendFile() {
      this.uploading = true
      this.$emit('uploading-changed', true)
      const response = await this.uploadMedia(this.attachment, this.accountId, 'true')
      if (response?.length > 0) {
        for (const media of response) {
          this.mediasList.push(media)
        }
        this.$nextTick(() => {
          this.attachment = []
          this.uploading = false
          this.$emit('uploading-changed', false)
          this.$emit('medias-list-updated', this.mediasList)
          this.initCount()
          this.$nextTick(() => {
            if (this.$refs['coozzy-file-input']) {
              this.$refs['coozzy-file-input'].resetPlaceholder()
            }
          })
        })
      } else {
        this.uploading = false
        this.$emit('uploading-changed', false)
      }
    },
    initCount() {
      this.countDocs = 0
      this.countImg = 0
      this.countVideo = 0
    },
    deleteMedia(e: MouseEvent, id: string) {
      e.stopPropagation()
      if (this.mediasList) {
        this.mediasList = this.mediasList.filter(el => el.id !== id)
        this.$emit('medias-list-updated', this.mediasList)
        this.initCount()
      }
    },
    isFutureTenant(id: string): boolean {
      if (id && this.tenancies.length > 0) {
        const tenant = this.tenancies.find(x => x.tenant?.contactIds?.includes(id))
        if (tenant) {
          const today = new Date()
          return new Date(this.$options.filters.objectToDateInput(tenant.startingAt)).getTime() >= today.getTime()
        }
        return false
      }
      return false
    },
    isFutureCondoOwner(id: string): boolean {
      if (id && this.condoOwners.length > 0) {
        const tenant = this.condoOwners.find(x => x.owner?.contactIds?.includes(id))
        if (tenant) {
          const today = new Date()
          return new Date(this.$options.filters.objectToDateInput(tenant.startingAt)).getTime() >= today.getTime()
        }
        return false
      }
      return false
    },
    itemSelected(ids: string[], contracts: string[]) {
      this.$emit('selected-contract', ids, contracts)
    },
    // getOwnersNames() {
    //   const promises = []
    //   if (this.ownersList.length > 0) {
    //     for (const id of this.ownersList) {
    //       promises.push(UserApi.getAccount(id))
    //     }
    //     Promise.all(promises).then((result) => {
    //       console.log('response :', result)
    //       const names = []
    //       result.forEach(response => {
    //         names.push(response.account?.company?.name)
    //       })
    //       console.log('names: ', names)
    //       this.$nextTick(() => {
    //         this.emitting.orderDescription = this.$t('message.createOrder.descriptionOrderDetails', { ownerBaseName: names.toString() })
    //       })
    //
    //     })
    //   }
    // },
    getContactName(contactId: string): string {
      const contact = this.combinedContacts.find(contact => contact.id === contactId)
      return contact ? contact.name : '-'
    },
    dateToObject() {
      this.emitting.executeFrom = this.toObject(this.dates.executeFrom)
      this.emitting.executeUntil = this.toObject(this.dates.executeUntil)
    },
    getDatesFromObjects: function () {
      this.dates.executeFrom = this.$options.filters.objectToDateInput(this.emitting.executeFrom)
      this.dates.executeUntil = this.$options.filters.objectToDateInput(this.emitting.executeUntil)
    },
    isInvalid(requireMandatoryFields = true): boolean {
      if (requireMandatoryFields) {
        this.$v.$touch()
        if (this.$v.$invalid) {
          if (this.$v.emitting.executeUntil.$dirty && this.$v.emitting.executeUntil.$error) {
            if (!this.$v.emitting.executeUntil.required) {
              Vue.toasted.show(this.$t('message.savingErrors.executeUntilRequired'), { type: 'error' })
            } else {
              Vue.toasted.show(this.$t('message.savingErrors.executeUntilBeforeExecuteFrom'), { type: 'error' })
            }
          }
          if (this.$v.selectedContactsUpdatesStatus && this.$v.selectedContactsUpdatesStatus.$dirty && this.$v.selectedContactsUpdatesStatus.$error) {
            Vue.toasted.show(this.$t('message.savingErrors.someContactNoEmail'), { type: 'error' })
          }
          return true
        }
        return false
      }

      // Draft save: skip Title / Assignee / Execute Until required, keep date-order and status-update email checks
      this.$v.emitting.executeUntil.$touch()
      this.$v.selectedContactsUpdatesStatus.$touch()

      if (!this.$v.emitting.executeUntil.greaterThanExecuteFrom) {
        Vue.toasted.show(this.$t('message.savingErrors.executeUntilBeforeExecuteFrom'), { type: 'error' })
        return true
      }
      if (this.$v.selectedContactsUpdatesStatus && this.$v.selectedContactsUpdatesStatus.$error) {
        Vue.toasted.show(this.$t('message.savingErrors.someContactNoEmail'), { type: 'error' })
        return true
      }

      return false
    },
    handleCheckboxesInsideStatusUpdatesTable(value: boolean) {
      if (this.$refs.contactsStatusUpdatesTable) {
        const allCheckboxesComponents = this.$refs.contactsStatusUpdatesTable.$children[1].$children
        this.handleCheckbox(allCheckboxesComponents, value)
      }
      if (this.$refs.header_checkbox_status_updates && value === false) {
        this.$refs.header_checkbox_status_updates.checked = false
      }
    },
    contactSelected(contact: StatusUpdateContact, checked: boolean) {
      if (checked) {
        this.selectedContactsUpdatesStatus.push(contact.id)
      } else {
        this.selectedContactsUpdatesStatus = this.selectedContactsUpdatesStatus.filter(entry => entry !== contact.id)
      }
      const filteredContact = this.filteredStatusUpdatesContacts.find(x => x.id === contact.id)
      if (filteredContact) {
        this.syncStatusUpdateContactRow(filteredContact)
      }
      this.emitSelectedStatusUpdateContacts()
    },
    handleCheckboxesInsideTenancyContactsTable(value: boolean) {
      if (this.$refs.tenancyContactsTable) {
        const allCheckboxesComponents = this.$refs.tenancyContactsTable.$children[1].$children
        this.handleCheckbox(allCheckboxesComponents, value)
      }
      if (this.$refs.header_checkbox_tenancy_contacts && value === false) {
        this.$refs.header_checkbox_tenancy_contacts.checked = false
      }
    },
    tenancyContactSelected(contact: TenancyContact, checked: boolean) {
      if (checked) {
        this.selectedTenants.push(contact)
      } else {
        this.selectedTenants = this.selectedTenants.filter(entry => entry.id !== contact.id)
      }
    },
    searchInputText() {
      this.filteredStatusUpdatesContacts = this.statusUpdatesContacts.filter(contact => {
        const cdtName = contact.name.toLowerCase().includes(this.querySearch.toLowerCase())
        const cdtType = contact.type.toLowerCase().includes(this.querySearch.toLowerCase())
        const cdtRole = contact.role.toLowerCase().includes(this.querySearch.toLowerCase())
        const cdtEmail = contact.email.toLowerCase().includes(this.querySearch.toLowerCase())
        return cdtName || cdtType || cdtRole || cdtEmail
      })
    },
    loadStatusUpdatesContacts() {
      this.statusUpdatesContacts = []
      this.combinedContacts.forEach(contact => {
        if (contact.id === this.operator?.id) {
          return
        }
        const tenancy = this.tenancies.find(tenancy => tenancy.tenant?.contactIds?.includes(contact.id))
        const object = this.objects.find(object => object.id === tenancy?.objectId) || null
        this.statusUpdatesContacts.push({
          id: contact.id,
          name: contact.name,
          type: object ? this.$t('message.onBoarding.buildings.objects.category.' + object.category.toLowerCase()) : '-',
          role: contact.types?.length > 0 ? contact.types.map(obj => this.$t('message.contact.types.' + obj.toUpperCase())).join(', ') : '',
          email: contact.email,
          contactPersons: this.filterActiveContactPersons(contact)
        })
      })
      this.$nextTick(() => {
        // add the item 'selectedContactPerson' if it doesn't exist when reloading the contacts
        for (let i = 0; i < this.statusUpdatesContacts.length; i++) {
          if (!('selectedContactPerson' in this.statusUpdatesContacts[i])) {
            this.statusUpdatesContacts[i].selectedContactPerson = null
          }
        }
        const contacts = [...new Set(this.statusUpdatesContacts.map(x => x.id))].map(id => {
          return this.statusUpdatesContacts.find(a => a.id === id)
        })
        this.filteredStatusUpdatesContacts = JSON.parse(JSON.stringify(contacts))
        this.resolveDraftStatusUpdateWatchers()
      })
    },
    loadTenanciesContacts() {
      this.listContactTenancies = []
      const list = []
      const referenceObjectIds = this.objectReferences
        .map((ref: ReferenceItem) => ref.id)
        .filter((id: string) => id && id.startsWith('obj'))
      this.tenantContacts.forEach(contact => {
        const tenancy = this.tenancies.find(tenancy => tenancy.tenant?.contactIds?.includes(contact.id))
        if (!tenancy) return
        if (referenceObjectIds.length > 0 && !referenceObjectIds.includes(tenancy.objectId)) return
        const object = this.objects.find(object => object.id === tenancy.objectId) || null
        list.push({
          id: contact.id,
          name: contact.name,
          type: object ? this.$t('message.onBoarding.buildings.objects.category.' + object.category.toLowerCase()) : '-',
          role: contact.types?.length > 0 ? contact.types.map(obj => this.$t('message.contact.types.' + obj.toUpperCase())).join(', ') : '',
          email: contact.email,
          contactPersons: this.filterActiveContactPersons(contact),
          phoneNumbers: contact.phoneNumbers,
          website: contact.website
        })
      })
      this.$nextTick(() => {
        // add the item 'selectedContactPerson' if it doesn't exist when reloading the contacts
        for (let i = 0; i < list.length; i++) {
          if (!('selectedContactPerson' in list[i])) {
            list[i].selectedContactPerson = null
          }
        }
        const contacts = [...new Set(list.map(x => x.id))].map(id => {
          return list.find(a => a.id === id)
        })
        this.listContactTenancies = JSON.parse(JSON.stringify(contacts))
      })
    },
    editStatusUpdatesContacts() {
      this.statusUpdatesContacts.forEach((element) => {
        const contact = this.combinedContacts.find(x => x.id === element.id)
        if (contact) {
          element.name = contact.name
          element.role = contact.types?.length > 0 ? contact.types.map(obj => this.$t('message.contact.types.' + obj.toUpperCase())).join(', ') : ''
          element.email = contact.email
          element.contactPersons = this.filterActiveContactPersons(contact)
        }
      })
      this.filteredStatusUpdatesContacts.forEach((element) => {
        const contact = this.combinedContacts.find(x => x.id === element.id)
        if (contact) {
          if (!element.selectedContactPerson) {
            element.name = contact.name
            element.role = contact.types?.length > 0 ? contact.types.map(obj => this.$t('message.contact.types.' + obj.toUpperCase())).join(', ') : ''
            element.email = contact.email
            element.contactPersons = this.filterActiveContactPersons(contact)
          } else {
            const newContactPerson = contact.contactPersons.find(x => x.id === element.selectedContactPerson)
            if (newContactPerson) {
              element.email = newContactPerson.email
            }
          }
        }
      })
    },
    editTenancyContacts() {
      this.listContactTenancies.forEach((element) => {
        const contact = this.combinedContacts.find(x => x.id === element.id)
        if (contact) {
          if (!element.selectedContactPerson) {
            element.name = contact.name
            element.role = contact.types?.length > 0 ? contact.types.map(obj => this.$t('message.contact.types.' + obj.toUpperCase())).join(', ') : ''
            element.email = contact.email
            element.contactPersons = this.filterActiveContactPersons(contact)
            element.phoneNumbers = contact.phoneNumbers
            element.website = contact.website
          } else {
            const newContactPerson = contact.contactPersons.find(x => x.id === element.selectedContactPerson)
            if (newContactPerson) {
              element.email = newContactPerson.email
              element.phoneNumbers = newContactPerson.phoneNumbers
              element.website = newContactPerson.website
            }
          }
        }
      })
    },
    selectContactToEdit(contact: Contact | Contactcontactv2ContactPerson | StatusUpdateContact | TenancyContact, from: string) {
      let isContactPerson = false
      if (this.combinedContacts.find(item => item.id === contact.id)) {
        isContactPerson = false
        this.contactToEdit = this.combinedContacts.find(item => item.id === contact.id)
      } else if (this.combinedContacts.find(item => 'contactPersons' in item && item.contactPersons?.find(x => x.id === contact.id))) {
        isContactPerson = true
        this.contactToEdit = this.combinedContacts.find(item => 'contactPersons' in item && item.contactPersons?.find(x => x.id === contact.id))
      }
      if (isContactPerson || ('selectedContactPerson' in contact && contact.selectedContactPerson !== null)) {
        if ('selectedContactPerson' in contact && contact.selectedContactPerson !== null) {
          this.selectedPerson = contact.contactPersons.find(x => x.id === contact.selectedContactPerson)
        } else {
          this.selectedPerson = contact
        }
        this.$nextTick(() => {
          this.showPerson()
        })
      } else {
        this.$nextTick(() => {
          this.editContactClicked(from)
        })
      }
    }
  },
  validations() {
    return {
      emitting: {
        executeUntil: {
          required,
          greaterThanExecuteFrom
        },
        selectedEmployee: {
          required
        }
      },
      title: {
        required
      },
      selectedContactsUpdatesStatus: {
        allContactHasEmail: helpers.withParams({ type: 'allContactHasEmail' }, (value: string[]) => {
          if (!this.sendStatusUpdates || value.length === 0) {
            return true
          }
          for (const contactId of value) {
            const statusContact = this.statusUpdatesContacts.find(c => c.id === contactId) ||
              this.filteredStatusUpdatesContacts.find(c => c.id === contactId)
            if (!statusContact || !this.resolveStatusUpdateContactEmail(statusContact)) {
              return false
            }
          }
          return true
        })
      }
    }
  }
})
</script>

<style lang="scss" scoped>

.uploaded-file {
  max-height: 100px;
  background-position: center center;
  background-size: cover;
  min-height: 5em;
}

.file-block {
  display: flex;
  align-items: center;
}

.delete-icon.image {
  position: absolute;
  right: 15px;
}

.delete-icon.video {
  position: absolute;
  right: 15px;
  top: 5px;
}

.media-block {
  padding: 0.5rem;
  padding-left: 0;
}

@media (min-width: 768px) {
  .uploaded-file {
    max-height: 100px;
    min-height: 4em;
  }
}

@media (min-width: 992px) {
  .uploaded-file {
    max-height: 110px;
    min-height: 5em;
  }
}

@media (min-width: 1200px) {
  .uploaded-file {
    max-height: 120px;
    min-height: 5.5em;
  }
}

@media (min-width: 1600px) {
  .uploaded-file {
    max-height: 130px;
    min-height: 7em;
  }
}

:deep(.v-select-custom) > div {
  height: calc(1.5em + 0.5rem + 2px);
}

:deep(.selected-option) {
  line-height: 1;
}
:deep(.adjustWidth) {
  width: 15px;
  height: 15px;
}
</style>
